export const name = 'gzAutoTooltip';

/**
 * @ngdoc directive
 * @name gazelle.components.printosImages.gzAutoTooltip.directive:gzAutoTooltip
 *
 * @param {string=} gzAutoTooltip tooltip to display if contents are clipped.  Optional.  If not specified shows element's text contents.
 *
 * @description
 * `gz-auto-tooltip` is an attribute directive for specifying a tooltip to show when contents are clipped.
 * Otherwise, tooltip is not shown.  Uses md-tooltip to manage the tooltip.
 *
 * @usage
 * ```html
 * <div gz-auto-tooltip>My text</div>
 * <div gz-auto-tooltip='My tooltip'>My text</div>
 * ```
 * Produces (if content is clipped)
 * ```html
 * <div gz-auto-tooltip>
 *     <md-tooltip>My text</md-tooltip>
 *     My text
 * </div>
 * ```
 */
export default function gzAutoTooltip($compile, $sanitize) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  let directive = {
    restrict: 'A',
    link: gzAutoTooltipLink,
  };

  return directive;

  //////////////////////

  function gzAutoTooltipLink(scope, element, attrs) {
    // Automatically add the gazelle class to clip with ellipsis
    if (!element[0].classList.contains('gz-ellipsis')) {
      element[0].classList.add('gz-ellipsis');
    }

    element.on("mouseenter", (event, tooltipTrigger) => {
      if (tooltipTrigger) {
        return;
      }

      if (element[0].offsetWidth < element[0].scrollWidth) {
        let tooltip = attrs.gzAutoTooltip;
        if (!tooltip) {
          tooltip = element.text();
        }

        if (tooltip) {
          tooltip = tooltip.replace(/{{/g, '');
          tooltip = tooltip.replace(/}}/g, '');
          tooltip = $sanitize(tooltip);
        }

        let keyEl = angular.element("<md-tooltip md-autohide='true'>" + tooltip + "</md-tooltip>");
        element.append(keyEl);
        $compile(keyEl)(scope);

        let leaveHandler = () => {
          keyEl.remove();
          element.off('mouseleave', leaveHandler);
        };

        element.on("mouseleave", leaveHandler);

        element.triggerHandler(event, true);
      }
    });
  }
}
